module.exports = __webpack_public_path__ + "videos/home-53-hero_16x9_jp.316f825.mp4";